import {doppeActionTypeDefineViewerMetadata} from "../../client-server-common/doppe-action-types/doppe-action-type";
import React from "react";
import {doppeActionTypeHoppPricingPlan} from "./doppe-action-type-hopp-pricing-plan";

export const doppeActionTypeHoppPricingPlanViewer = doppeActionTypeDefineViewerMetadata(doppeActionTypeHoppPricingPlan, {

    loadViewerComponents: async () => {
        return {
            DoppeActionTypeHoppPricingPlanWidget: (await import(
                './doppe-action-type-hopp-pricing-plan-widget/doppe-action-type-hopp-pricing-plan-widget'
            )).DoppeActionTypeHoppPricingPlanWidget
        }
    },

    renderWidget: (renderProps, viewerComponents) => {

        const {
            DoppeActionTypeHoppPricingPlanWidget
        } = viewerComponents;

        return (
            <DoppeActionTypeHoppPricingPlanWidget
                {...renderProps}
            />
        );
    }
}) 